import {
  Alert,
  AlertIcon,
  Box,
  CircularProgress,
  CloseButton,
  Flex,
  Form,
  Modal, ModalOverlay, ModalContent, ModalCloseButton, ModalBody,
  Text,
  ModalHeader,
  ModalFooter,
  Button, Input
} from '@stars-ecom/shared-atoms-ui'
import { navigate } from 'gatsby'
import React, { useContext, useState } from 'react'

import { ApiContext, UserContext, WebsiteContext } from '../context'
import { CustomerHelper } from '../utils'
import accountEdit from './forms/accountEdit.schema'
import checkoutEditAccount from './forms/checkoutEditAccount.schema.js'

const ModalRGPD = (props) => {
  const {
    websiteContext,
    isOpen,
    onClose,
    onValid,
    apiContext,
    currentUser
  } = props;
  const [ pwdError, setPwdError ] = useState(false);
  const [ password, setPassword ] = useState('');
  const [ loading, setLoading ] = useState(false);

  const _onValid = async () => {
    if (!password || password.length < 1) return setPwdError(true);
    setLoading(true);
    const result = await apiContext?.AccountApi?.deleteUserAccount(currentUser, password);
    setLoading(false);
    if (!!result?.data?.error || !!result?.error) return setPwdError(true);
    return onValid();
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="xl"
      scrollBehavior="inside"
      className="chakra-modal__delete-user-account"
      isCentered={!websiteContext.isMobile}>
      <ModalOverlay />
      <ModalContent maxW="50rem" borderRadius="0" minH={{ base: '600px', md: 'unset' }}>
        <ModalCloseButton
          style={{ boxShadow: 'none', zIndex: 10000, right: '0', top: '0' }}
          _hover={{ boxShadow: 'none' }}
          _active={{ boxShadow: 'none' }}
        />
        <ModalHeader>
          Suppression du compte client
        </ModalHeader>
        <ModalBody>
          <Flex
            w="100%"
            position="relative"
            direction={{ base: 'column' }}
            id="deleteMyAccount"
          >
            <Text
              fontSize="18px"
              mb="5px"
              fontFamily="PT Sans"
            >
              Toutes les données du compte seront supprimées immédiatement !
            </Text>
            <Text
              fontSize="18px"
              mb="16px"
              fontFamily="PT Sans"
              decoration={"underline"}
              color={"red"}
            >
              Cette action est irréversible.
            </Text>
            <Text
              fontSize="18px"
              mb="16px"
              fontFamily="PT Sans"
            >
              Veuillez entrer votre mot de passe actuel afin de confirmer la suppression de votre compte.
            </Text>
            <form
              style={{ display: 'flex', flexDirection: 'column' }}>
              <Input
                value={password}
                pr="4.5rem"
                type="password"
                placeholder="Votre mot de passe"
                backgroundColor="white"
                borderRadius="0px"
                borderColor={pwdError ? 'red' : 'unset'}
                _focus={{ borderColor: '#c1c1c1' }}
                border={pwdError ? '2px solid red' : '1px solid #c1c1c1'}
                fontSize="14px"
                onChange={(e) => {
                  setPassword(e.target.value);
                  if (!!pwdError) setPwdError(false);
                }} />
              {pwdError && (
                <Text color="red" fontSize="12px" lineHeight="12px" mt="5px" mb="5px">
                  Ce champ est obligatoire ou incorrect !
                </Text>
              )}
            </form>
          </Flex>
        </ModalBody>
        <ModalFooter>
          <Flex
            direction={{ base: 'column', md: 'row' }}
            w="100%"
            justify={'space-between'}
          >
            <Button
              order={{ base: 2, md: 1 }}
              w={{ base: '100%', md: 'auto' }}
              variant="solid"
              style={{
                borderRadius: 0,
                color: '#ffffff',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center',
                height: '40px',
                paddingLeft: '30px',
                paddingRight: '30px',
                boxShadow: 'none'
              }}
              textTransform="uppercase"
              fontSize="16px"
              fontWeight="400"
              fontFamily={websiteContext?.fontFamily}
              mb={{ base: '20px', md: '0px' }}
              backgroundColor="#c1c1c1"
              onClick={onClose}
            >
              Annuler
            </Button>
            <Button
              order={{ base: 1, md: 2 }}
              w={{ base: '100%', md: 'auto' }}
              variant="solid"
              style={{
                borderRadius: 0,
                color: '#ffffff',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center',
                height: '40px',
                paddingLeft: '30px',
                paddingRight: '30px',
                boxShadow: 'none'
              }}
              textTransform="uppercase"
              fontSize="16px"
              fontWeight="400"
              fontFamily={websiteContext?.fontFamily}
              cursor={!!password && password.length > 1 ? 'pointer' : 'not-allowed'}
              disabled={(!(!!password && password.length > 1) || !!loading)}
              mb={{ base: '20px', md: '0px' }}
              backgroundColor={websiteContext?.mainColor}
              _hover={{ bg: websiteContext?.darkColor }}
              onClick={_onValid}
            >
              {loading ? 
                <Flex align="center">
                  <CircularProgress size={'25px'} isIndeterminate color={websiteContext?.mainColor} />
                </Flex>
                : "Valider"
              }
            </Button>
          </Flex>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

const AccountEdit = (props) => {
  const { isCheckout = false } = props
  const currentUser = useContext(UserContext)
  let billingAddress = CustomerHelper.getDefaultBillingAddress(currentUser)
  if (!billingAddress) {
    billingAddress = {
      country: {
        name: process.env.GATSBY_API_COUNTRY
      }
    }
  }
  const websiteContext = useContext(WebsiteContext)
  const apiContext = useContext(ApiContext)
  const [loading, setLoading] = useState(false)
  const [ isModalOpen, setModalOpen ] = useState(false); 
  const [alert, setAlert] = useState(false)
  const windowGlobal = typeof window !== 'undefined' && window
  const scrollToTop = () => windowGlobal.scrollTo({ top: 0, behavior: 'smooth' })

  const validateFunction = async (val) => {
    const result = await apiContext?.AccountApi?.updateUser(
      {
        ...val?.currentUser,
        currentPassword: val?.currentPassword,
        newPassword: val?.newPassword,
        confirmNewPassword: val?.confirmNewPassword
      },
      val?.billingAddress,
      isCheckout
    )
    scrollToTop()
    if (result && !result?.error) {
      setAlert({
        status: 'success',
        message: 'Les informations du compte ont été sauvegardées'
      })
      if (isCheckout) {
        navigate('/checkout/shipping', { replace: true })
      }
    } else if (result?.error == 'EmailAddressConflictError') {
      setAlert({
        status: 'error',
        message: 'E-mail déjà associé à un compte client : merci de saisir un autre e-mail.'
      })
    } else {
      setAlert({
        state: 'error',
        message: 'Veuillez vérifier votre mot de passe'
      })
    }
  }

  const cancelFunction = async () => {
    scrollToTop()
  }

  const deleteMyAccount = async () => {
    window.alert("Votre compte a bien été supprimé ! Vous allez être déconnecté !");
    setModalOpen(!isModalOpen);
    await apiContext?.AccountApi?.logout();
    window.location.assign('/');
  }
  const showRgpdModal = async () => {
    setModalOpen(!isModalOpen);
  }

  return (
    <Flex direction="column" width="100%" position="relative">
      {alert && (
        <Alert status={alert.status}>
          <AlertIcon />
          {alert.message}
          <CloseButton
            position="absolute"
            right="8px"
            top="8px"
            onClick={() => {
              setAlert(null)
            }}
          />
        </Alert>
      )}
      <Flex
        direction="column"
        padding={{ base: '0px 15px 30px', md: '40px' }}
        backgroundColor="#ffffff">
        {!billingAddress && !loading && (
          <Text
            fontFamily={websiteContext?.fontFamily}
            fontSize="14px"
            color="#333333"
            mt="15px"
            mb="15px">
            Veuillez compléter vos informations personnelles en saisissant votre adresse de
            facturation.
          </Text>
        )}
        {
          <Form
            formSettings={isCheckout ? checkoutEditAccount : accountEdit}
            originValue={{
              currentUser,
              billingAddress,
              currentPassword: '',
              newPassword: '',
              confirmNewPassword: ''
            }}
            validateFunction={validateFunction}
            cancelFunction={cancelFunction}
            middleFunction={showRgpdModal}
            middleText={"Supprimer mon compte"}
            formOptions={{ mainColor: websiteContext?.mainColor }}
            setLoading={setLoading}
            isCheckout={isCheckout}
          />
        }
      </Flex>
      <Box
        mt="20px"
        mb="10px"
        fontSize="11px"
        ml={{ md: '20px' }}
        fontFamily="PT Sans Narrow"
        color="#5e5e5e"
        align="justify"
        sx={{
          '& a': {
            color: websiteContext?.mainColor,
            '&:hover': {
              textDecoration: 'underline',
              color: websiteContext?.darkColor
            }
          }
        }}
        dangerouslySetInnerHTML={{ __html: websiteContext?.legalMention }}
      />
      {loading && (
        <Flex
          position="absolute"
          width="100%"
          height="100%"
          justify="center"
          paddingTop="90px"
          style={{ backgroundColor: 'rgb(0, 0, 0, 0.2)' }}>
          <CircularProgress isIndeterminate color={websiteContext?.mainColor} />
        </Flex>
      )}
      { isModalOpen && <ModalRGPD
        websiteContext={websiteContext}
        isOpen={isModalOpen}
        onClose={showRgpdModal}
        onValid={deleteMyAccount}
        apiContext={apiContext}
        currentUser={currentUser}
      />}
    </Flex>
  )
}

export default AccountEdit
